import axios from "axios";
import { IProductsWithSchedules, IDeleteScheduleResult } from "../../models/LeadTimes";
import { getConfig } from "../../modules/Config/Config";
import { Product, Schedule } from "../ProductsContext";

export interface IQueryResults {
  entities: Product[];
  schedules?: Schedule[];
  totalCount: number;
  errorMessage: string;
}
export interface IPutProduct {
  plantCode: string;
  articleCode: string;
  isPremiumLayFlat?: boolean;
  productionLeadTimeDays: number;
}

async function getProductsWithSchedules(productGroupName: string, plantCode: string): Promise<IQueryResults> {
  const backendConfig = await getConfig("backend");
  return axios
    .get<IProductsWithSchedules>(
      `${backendConfig.url}/leadtime/${plantCode}/${productGroupName}/withschedules`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => {
      return {
        entities: response.data.leadTimes.map((val) => {
          return {
            id: val.productCode,
            desc: val.description,
            leadTime: val.leadTime,
            productOptionLeadTimes: val.productOptionLeadTimes,
            scheduledLeadTimes: val.scheduledLeadTimes,
            isActive: val.isActive,
          } as Product;
        }),
        schedules: response.data.schedules,
        totalCount: response.data.leadTimes.length,
        errorMessage: "",
      };
    });
}

async function deleteScheduleWithId(plantCode: string, productGroup: string, scheduleId: string): Promise<IDeleteScheduleResult> {
  const backendConfig = await getConfig("backend");
  const url = `${backendConfig.url}/leadtime/${plantCode}/${productGroup}/${scheduleId}`;
  return axios
    .delete(url, {
      headers: {
        "Content-Type": "application/json",
      }
    })
    .then((response) => response.data);
}

async function exportScheduleWithId(plantCode: string, productGroup: string, scheduleId: string): Promise<any> {
  const backendConfig = await getConfig("backend");
  const url = `${backendConfig.url}/leadtime/${plantCode}/${productGroup}/${scheduleId}/export`;
  return axios
    .get(url, {
      headers: {
        "Content-Type": "application/json",
      }
    })
    .then((response) => response.data);
}

export { getProductsWithSchedules, deleteScheduleWithId, exportScheduleWithId };
